module.exports = __webpack_public_path__ + "img/10.c3ec1f2c.gif";